import React from "react";
import useConfiguration from "../../../../hooks/useConfiguration";
import useSessionStorage from "../../../../hooks/useSessionStorage";
import { localHostBaseURL } from "../../../../helpers/domainURL";
import { setLoadingFlagDecrement, setLoadingFlagIncrement } from "./slice";
import { useDispatch } from "react-redux";
import * as Toasts from '../../../common/Toastify';

const ResumeFile = (props) => {
  const { resumeFileName, fileId, noResume, candidateUniqueId } = props;
  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const baseUrl = config.baseUrl;
  const downloadResume = async () => {
    const requestHeaders = {
      "Content-Type": "application/json",
      Authorization: login.accessToken ? `Bearer ${login.accessToken}` : "",
      "Website-Domain-Name":
        window.location.hostname === "localhost"
          ? localHostBaseURL
          : window.location.hostname ,
    };
    const params = {
      candidateUniqueId: candidateUniqueId ?? "",
      "attachmentFileId": 0
    };
    try {
      dispatch(setLoadingFlagIncrement());
      const response = await fetch(
        `${baseUrl}/Employers/get-employer-resume-download`,
        {
          headers: { ...requestHeaders },
          method: "POST",
          body: JSON.stringify(params),
        }
      );
      const blob = await response.blob();
      let downnloadURL = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = downnloadURL;
      a.download = resumeFileName;
      a.click();
    } catch (error) {
      Toasts.error(error.message);
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
  return (
    <div>
      <h4 className="view-heading">Resume Upload</h4>
      <section>
        {resumeFileName ? (
          <a
          style={{cursor:"pointer"}}
            // href="#"
            onClick={downloadResume}
            // href={`${baseUrl}/Candidates/getresumefile/${fileId}`}
            // target="_blank"
            rel="noreferrer"
          >
            <i>{resumeFileName}</i>
            <i
              className="mdi mdi-arrange-bring-forward"
              data-bs-toggle="tooltip"
              title=""
              data-bs-original-title="mdi-arrange-bring-forward"
              aria-label="mdi-arrange-bring-forward"
            ></i>{" "}
          </a>
        ) : noResume ? (
          <span> No Resume</span>
        ) : null}
      </section>
    </div>
  );
};

export default ResumeFile;
